/* eslint-disable max-len */
import React from "react"
import { Link } from "gatsby"
import { Wrapper } from "./Navigation.styles"
import Icon from "../Icon/Icon"
import { useState } from "react"
import PropTypes from "prop-types"

function NavBar({ menu }) {
  let i = 0
  return (
    <Wrapper>
      <ul>
        {menu.map(mainItem =>
          !mainItem.parentId // necessary for each component to get it's own clickhandler
            ? ClickHandler(mainItem, i)
            : null
        )}
      </ul>
    </Wrapper>
  )
}

function removeClass(className) {
  const elements = document.querySelectorAll(`.${className}`)

  elements.forEach(element => {
    element.classList.remove(className)
  })
}

function ClickHandler(mainItem, i) {
  const [click, setClick] = useState(false)
  const handleClick = () => {
    console.log("setting click!!")
    removeClass("active")
    removeClass("nav-active")

    setClick(!click)
  }

  function keydown(event) {
    if (event.keyCode === 13) {
      console.log("handling keydown!!")
      removeClass("active")
      removeClass("nav-active")
      setClick(!click)
    }
  }

  return (
    // build menu item and child menu
    <li key={mainItem.id}>
      <button
        key={mainItem.id}
        href={mainItem.url}
        onClick={() => handleClick()}
        onKeyDown={e => keydown(e)}
        tabIndex={i}
        className={click ? "nav nav-active" : "nav"}
      >
        {mainItem.label}
        {mainItem.childItems.nodes.length > 0 ? (
          <>
            {mainItem.childItems.nodes.length !== 0 && click ? (
              <div>
                <Icon className="icon" category="Up Arrow" />
              </div>
            ) : (
              <div>
                <Icon className="icon" category="Down Arrow" />
              </div>
            )}

            {mainItem.childItems.nodes.length > 0 ? (
              <ul className={click ? "active" : ""}>
                {mainItem.childItems.nodes.map(childItem => {
                  return (
                    <li key={childItem.id}>
                      {childItem.url.charAt(0) === "/" ? (
                        <Link
                          to={childItem.url}
                          activeClassName="nav-active"
                          className="secondaryLink"
                        >
                          {childItem.label}
                        </Link>
                      ) : (
                        <a href={childItem.url} className="secondaryLink">
                          {childItem.label}
                        </a>
                      )}
                    </li>
                  )
                })}
              </ul>
            ) : null}
          </>
        ) : null}
      </button>
    </li>
  )
}

NavBar.propTypes = {
  menu: PropTypes.array,
}

export default NavBar
